import { useQuery } from '@tanstack/react-query';

import { stripeAccountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useHasScheduledDowngrade = (enabled = false) => {
  const query = useQuery({
    queryKey: [QueryKeys.HAS_SCHEDULED_DOWNGRADE],
    queryFn: () => stripeAccountRepo.getHasScheduledDowngrade(),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseHasScheduledDowngrade = ReturnType<typeof useHasScheduledDowngrade>;
